import L from 'leaflet';

// The hovered / opened areas' own outlines (kartvy's showOutline), drawn above the dimming and the green line
// around a search (areaSelectionOverlay.js, z 420), so every edge of the area, also one it shares with the
// search's edge, shows the area's colour at its hover width instead of the green line. Below the map labels
// (440) and the listings (600). SVG, not canvas: the pane holds one or two paths, and a mostly empty SVG costs
// next to nothing to composite, where another full-screen canvas would cost as much as the area canvas.

export const AREA_TOP_OUTLINE_PANE = 'areaTopOutlinePane';

export const areaTopOutlineRenderer = (map) => {
    if (!map) return null;
    if (!map.__areaTopOutlineRenderer) {
        const pane = map.getPane(AREA_TOP_OUTLINE_PANE) || map.createPane(AREA_TOP_OUTLINE_PANE);
        pane.style.zIndex = '425';
        pane.style.pointerEvents = 'none';
        map.__areaTopOutlineRenderer = L.svg({ pane: AREA_TOP_OUTLINE_PANE, padding: 0.5 });
    }
    return map.__areaTopOutlineRenderer;
};
